export default __webpack_public_path__ + "static/media/eduBlack.bffa14bd.svg";